export default "__VITE_ASSET__BXiOjE1y__"